module.exports = __webpack_public_path__ + "static/media/pass.5b0bcc9c.png";